import { ClipboardDocumentIcon, MapPinIcon, TruckIcon } from '@heroiconsv2/react/24/outline'
import { LABEL, PANEL, SectionCard } from './BookingSection'

const mapsUrl = (location, branch) => `https://www.google.com/maps/search/?api=1&query=${location?.coordinates?.[1] || branch?.lat},${location?.coordinates?.[0] || branch?.lon}`

const AddressRow = ({ label, address, href }) => (
  <div className="flex items-start gap-3 border-b border-slate-100 py-3 last:border-b-0">
    <MapPinIcon className="mt-0.5 h-4 w-4 flex-shrink-0 text-slate-400" />
    <div className="min-w-0 flex-1">
      <div className={LABEL}>{label}</div>
      <a href={href} target="_blank" rel="noopener noreferrer" className="mt-1 block break-words text-sm text-blue-700 hover:text-blue-900 hover:underline">
        {address}
      </a>
    </div>
    {address && (
      <button
        type="button"
        onClick={() => navigator.clipboard?.writeText(address)}
        className="flex-shrink-0 rounded-md p-1 text-slate-400 transition hover:bg-slate-100 hover:text-slate-700"
        title={address}
      >
        <ClipboardDocumentIcon className="h-4 w-4" />
      </button>
    )}
  </div>
)

const BookingDeliveryCard = ({ bookingData, t }) => (
  <SectionCard icon={TruckIcon} title={t('booking.sections.deliveryDetails')}>
    <div className={PANEL}>
      <AddressRow
        label={t('booking.labels.pickupAddress')}
        address={bookingData?.delivery?.pickupLocationAddress || bookingData?.branch?.address}
        href={mapsUrl(bookingData?.delivery?.pickupLocation, bookingData?.branch)}
      />
      <AddressRow
        label={t('booking.labels.dropOffAddress')}
        address={bookingData?.delivery?.dropOffLocationAddress || bookingData?.branch?.address}
        href={mapsUrl(bookingData?.delivery?.dropOffLocation, bookingData?.branch)}
      />
      {bookingData?.flightNumber ? (
        <div className="flex flex-col gap-1 py-3 sm:flex-row sm:items-center sm:justify-between">
          <div className={LABEL}>{t('booking.labels.flightNumber')}</div>
          <div className="text-sm font-medium text-slate-900" dir="ltr">
            {bookingData.flightNumber}
          </div>
        </div>
      ) : null}
    </div>
  </SectionCard>
)

export default BookingDeliveryCard
